import styles from './Buttons.module.scss'

export const PrimaryBigButton = ({ children, className, ...props }) => (
  <button {...props} className={[styles.primaryButton, className].join(' ')}>
    {children}
  </button>
)

export const SecondaryBigButton = ({ children, className, ...props }) => (
  <button {...props} className={[styles.secondaryButton, className].join(' ')}>
    {children}
  </button>
)
